import { Col, Row } from "antd";
import React from "react";
import { Link } from "react-router-dom";

const DigitalSignature = ({
  storeObject,
  setStoreObject,
  errors,
  setErrors,
}) => {
  return (
    <>
      <p class="font-weight-bolder font-size-lg mb-3 h5">Digital Signature</p>

      <div className="repeat_div mt-7">
        <Row gutter={[24, 24]}>
          <Col sm={12}>
            <div className="d-flex justify-content-between">
              <label className="font-weight-bolder font-size-sm text-capitalize">
                Upload Signature Image
                <span style={{ color: "red" }}>*</span>
              </label>

              <label className="font-weight-bolder text-warning font-size-sm text-capitalize">
                Signature Size 200*100
              </label>
            </div>
            <input
              type="file"
              className={
                errors?.digitalSignature
                  ? "invalid h-auto form-control"
                  : "h-auto form-control"
              }
              accept=".png, .jpg, .jpeg"
              onChange={(e) => {
                const file = e.target.files?.[0];
                if (!file) return;
                const allowedTypes = ["image/png", "image/jpeg", "image/jpg"];
                if (!allowedTypes.includes(file.type)) {
                  setStoreObject({
                    ...storeObject,
                    digitalSignature: null,
                  });
                  setErrors({
                    ...errors,
                    digitalSignature:
                      "Only PNG, JPG and JPEG files are allowed",
                  });
                  e.target.value = null;
                  return;
                }
                const sanitizedFileName = file.name.replace(/\s+/g, "");
                console.log("sanitizedFileName", sanitizedFileName);

                const renamedFile = new File([file], sanitizedFileName, {
                  type: file.type,
                  lastModified: file.lastModified,
                });

                setStoreObject({
                  ...storeObject,
                  digitalSignature: renamedFile,
                });

                setErrors({
                  ...errors,
                  digitalSignature: null,
                });
              }}
            />
            <small className="text-danger text-capitalize">
              {errors?.digitalSignature}
            </small>
          </Col>
          {storeObject?.digitalSignatureUrl && (

          <Col sm={12}>
            <div className="imgPreview m-0 ml-auto max-w-150px">
              <Link
                to={storeObject?.digitalSignatureUrl}
                className="document_file"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                alt="Digital Signature img"
                  src={storeObject?.digitalSignatureUrl}
                  className="w-100 max-w-150px"
                />
              </Link>
            </div>
          </Col>

          )}
        </Row>
      </div>
    </>
  );
};

export default DigitalSignature;